import React from "react";

interface OdxMainFilterGroupProps {
    children: React.ReactNode;
}

/**
 * Main filter group component. Placed above the page content and contains the filter group content.
 * @param children The children to display in the main filter group content. Can be filled with ODX components.
 * @constructor
 */
const OdxMainFilterGroup: React.FC<OdxMainFilterGroupProps> = ({children}) => {
    return (
        <div className={`odx-mainfilter-group flex flex-row [column-gap:var(--odx-grid-gutter)]`}>
            {children}
        </div>
    )
}

export default OdxMainFilterGroup;